import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchaseOrderAdvancedActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/PurchaseOrderAdvanced/PurchaseOrderAdvancedBrowser")
	}

	render() {
		return (
			<Activity 
				name="PurchaseOrder"
				RenderedComponent={this.RenderedComponent}
				context="PurchaseOrder"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchaseOrderAdvancedActivity)
